(async () => {
    const { Core } = await importModule('Core');

    customElements.define('collection-modal-filters', class extends Core {

        subscriptions = {
            'collection:updated': '_onCollectionChange',
        }

        render() {
            this.subscribe('collection:updated');
            this.addEventListener('click', this._clickHandler.bind(this));
        }
         _clickHandler(e) {
              if(e.target.tagName == "A" && e.target.closest(".collection-filters-drawer-reset-button")){
              e.preventDefault();
              var url = e.target.getAttribute("href");
              var data = {
                url: url
              }
           //debugger;
              this.publish('filter:change',data);
              }
         }     
        _onCollectionChange({ doc }) {
            this.replaceChildren(...doc.querySelector(`${this.getAttribute('target')}`).querySelector(`${this.tagName}[section-id=${this.sectionId}]`).cloneNode(true).childNodes);
        }        
    })
})();
